import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { modules } from '../data/content';
export function Modules() {
  return <section aria-label="Included modules" className="bg-graphite px-3 py-4 sm:px-6" data-id="element-111" data-mp="1r4sov7zfhav5">
      <div className="mx-auto max-w-2xl space-y-2" data-id="element-112" data-mp="1vy3pgrdncvem">
        {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-steel/20 bg-carbon" data-id="element-113" data-mp="20wewyvggytto">
            <div className="flex items-center gap-1.5 bg-volt px-2.5 py-1.5" data-id="element-114" data-mp="146xtmn4yljv5">
              <CheckCircle2Icon className="h-3.5 w-3.5 shrink-0 text-carbon" strokeWidth={2.5} aria-hidden="true" data-id="element-115" data-mp="186y7o6o5bt1o" />
              <h3 className="text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-carbon sm:text-[0.88rem]" data-id="element-116" data-mp="1d5j743vkq8p2">
                MODULE {mod.number} — {mod.title}
              </h3>
            </div>
            <p className="px-2.5 py-2 text-[0.78rem] leading-[1.35] text-steel sm:text-[0.92rem]" data-id="element-117" data-mp="2oky77gj2xgoe">{mod.body}</p>
          </article>)}
      </div>
    </section>;
}